// Tubular library pickers — Kick Sheet only (Commit 2).
//
// Pure read-only helper that filters /lib/reference/merged_library_v1.json
// equipment[] for use in TubularLibraryField dropdowns. No formulas, no I/O.
//
// Each picker returns an array of UI-shaped rows:
//   { id, label, od_in, id_in, weight_lbft, grade, nominal_size, type }
//
// Manual entry is always allowed (the field consumer can ignore the dropdown).

import lib from "./merged_library_v1.json";

export const LIB_VERSION = "rsc_seed_v1";

const _trim = (v) => (typeof v === "string" ? v.trim() : v);

function _row(e) {
  return {
    id: e.id,
    type: _trim(e.type),
    od_in: typeof e.od_in === "number" ? e.od_in : null,
    id_in: typeof e.id_in === "number" ? e.id_in : null,
    weight_lbft: e.weight_lbft ?? null,
    grade: e.grade ?? null,
    nominal_size: _trim(e.nominal_size) || null,
    label: _label(e),
  };
}
function _label(e) {
  const size = _trim(e.nominal_size) || (e.od_in != null ? `${e.od_in} in` : "");
  const wt   = e.weight_lbft ? `${e.weight_lbft} lb/ft` : "";
  const gr   = e.grade ? `Gr ${e.grade}` : "";
  return [size, wt, gr].filter(Boolean).join(" · ") || e.id;
}

function _byType(t) {
  const want = t.toLowerCase();
  return (lib.equipment || [])
    .filter((e) => (_trim(e.type) || "").toLowerCase() === want)
    .map(_row);
}

export const listDrillPipe   = () => _byType("drill_pipe");
export const listDrillCollar = () => _byType("drill_collar");
export const listCasing      = () => _byType("casing");
export const listTubing      = () => _byType("tubing");
export const listHwdp        = () => _byType("heavy_weight_drill_pipe");
export const listMudMotor    = () => _byType("mud_motor");
export const listRss         = () => _byType("rotary_steerable");
export const listMwd         = () => _byType("mwd_tool");
export const listLwd         = () => _byType("lwd_tool");
export const listStabilizer  = () => _byType("stabilizer");
export const listCrossover   = () => _byType("crossover");

// Hole size derives from bits — bit OD ≡ nominal hole size.
export function listHoleSizes() {
  return (lib.equipment || [])
    .filter((e) => (_trim(e.type) || "").toLowerCase() === "bit")
    .map((e) => ({
      id: e.id,
      type: "bit",
      od_in: e.bit_size_in || e.nominal_size_in || _parseSize(_trim(e.nominal_size) || e.id),
      id_in: null,
      grade: null,
      nominal_size: _trim(e.nominal_size) || null,
      label: _trim(e.nominal_size) || e.id,
    }))
    .filter((r) => Number.isFinite(r.od_in));
}
function _parseSize(s) {
  if (!s) return null;
  const m = /([0-9]+(?:\.[0-9]+)?)/.exec(s);
  return m ? parseFloat(m[1]) : null;
}

// Master dispatcher used by TubularLibraryField.
export function listByKind(kind) {
  switch ((kind || "").toLowerCase()) {
    case "drill_pipe":   return listDrillPipe();
    case "drill_collar": return listDrillCollar();
    case "casing":       return listCasing();
    case "tubing":       return listTubing();
    case "hwdp":         return listHwdp();
    case "mud_motor":    return listMudMotor();
    case "rss":          return listRss();
    case "mwd":          return listMwd();
    case "lwd":          return listLwd();
    case "stabilizer":   return listStabilizer();
    case "crossover":    return listCrossover();
    case "hole_size":
    case "bit":          return listHoleSizes();
    default: return [];
  }
}
